
import { PatientJourney } from "@/components/PatientJourney";
import { Approaches } from "@/components/Approaches";
import { BlogCarousel } from "@/components/BlogCarousel";
import { InstagramFeed } from "@/components/InstagramFeed";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { AccessibilityButton } from "@/components/AccessibilityButton";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { CTASection } from "@/components/CTASection";

export function DesktopHome() {
  return (
    <div className="min-h-screen bg-white font-primary">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <HeroSection />

      {/* Patient Journey */}
      <div className="px-4 sm:px-6">
        <PatientJourney />
      </div>

      {/* Approaches */}
      <div className="px-4 sm:px-6">
        <Approaches />
      </div>

      {/* Blog Carousel */}
      <div className="px-4 sm:px-6">
        <BlogCarousel />
      </div>

      {/* Instagram Feed */}
      <div className="px-4 sm:px-6">
        <InstagramFeed />
      </div>

      {/* FAQ */}
      <div className="px-4 sm:px-6">
        <FAQ />
      </div>

      {/* Testimonials */}
      <div className="px-4 sm:px-6">
        <TestimonialsSection />
      </div>

      {/* CTA Section */}
      <div className="px-4 sm:px-6">
        <CTASection />
      </div>

      {/* Footer */}
      <Footer />

      {/* Floating Components */}
      <FloatingWhatsApp />
      <AccessibilityButton />
    </div>
  );
}
